import script from "./SubMaterialTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMaterialTable.vue?vue&type=script&setup=true&lang=js"

import "./SubMaterialTable.vue?vue&type=style&index=0&id=7cf9075a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf9075a"]])

export default __exports__